module.exports = __webpack_public_path__ + "static/media/cutsheet.b0b18d58.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/flexhouse/cutsheet.mp4
// module id = 359
// module chunks = 0